export function parseGeomSelectionKey(geomKey) {
  if (!geomKey) {
    return { bodyUuid: null, geomUuid: null };
  }
  const value = String(geomKey);
  const separatorIndex = value.indexOf(":");
  if (separatorIndex <= 0) {
    return { bodyUuid: null, geomUuid: value };
  }
  return {
    bodyUuid: value.slice(0, separatorIndex),
    geomUuid: value.slice(separatorIndex + 1),
  };
}

export function findGeomNode(bodiesRecord, geomKey) {
  if (!bodiesRecord || !geomKey) return null;
  const { bodyUuid: hintedBodyUuid, geomUuid } = parseGeomSelectionKey(geomKey);
  if (!geomUuid) return null;

  const matchInBody = (body, targetGeomUuid) => {
    const geoms = Array.isArray(body?.geoms) ? body.geoms : [];
    for (const geom of geoms) {
      if (!geom) continue;
      if (String(geom.uuid) === targetGeomUuid) {
        return {
          bodyUuid: body.uuid,
          bodyName: body.name,
          geom,
        };
      }
    }
    return null;
  };

  if (hintedBodyUuid) {
    const hintedBody = bodiesRecord[hintedBodyUuid] || null;
    const directMatch = hintedBody ? matchInBody(hintedBody, geomUuid) : null;
    if (directMatch) return directMatch;
  }

  for (const body of Object.values(bodiesRecord)) {
    const match = matchInBody(body, geomUuid);
    if (match) return match;
  }

  return null;
}
